/** ספרות בלבד — 9 ספרות אחרונות (ישראל), לזיהוי 050 / +972 */
export function phoneDigitsKey(phone) {
  if (phone == null || phone === "") return "";
  let d = String(phone).replace(/\D/g, "");
  if (d.startsWith("972")) d = d.slice(3);
  if (d.startsWith("0")) d = d.slice(1);
  return d.length >= 9 ? d.slice(-9) : d;
}
